import { Navigate, useLocation, useParams } from "react-router-dom";

export default function LegacyApplicationDetailRedirect() {
  const { applicationId } = useParams();
  const location = useLocation();

  return (
    <Navigate to={`/people/membership-services/applications/${applicationId}/overview${location.search}`} replace />
  );
}
